// @flow
import { useState, useEffect } from 'react'

const CACHE_KEY = 'user_geo'
const CACHE_TTL = 1000 * 60 * 60 * 24 // 24 hours

export function useGeolocation (): {countryCode: ?string, isLoading: boolean} {
  const [countryCode, setCountryCode] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect((): void => {
    const fetchGeo = async (): Promise<void> => {
      // Check cache first
      try {
        const cached = localStorage.getItem(CACHE_KEY)
        if (cached) {
          const { country, timestamp } = JSON.parse(cached)
          if (Date.now() - timestamp < CACHE_TTL) {
            setCountryCode(country)
            setIsLoading(false)
            return
          }
        }
      } catch (e) {
        console.error('Cache read error:', e)
      }

      // Fetch fresh data
      try {
        // Using ipapi.co - free tier allows 1000 requests/month
        const response = await fetch('https://ipapi.co/json/')
        if (!response.ok) throw new Error('Geo API failed')

        const data = await response.json()
        const country = data.country_code

        setCountryCode(country)

        // Cache the result
        localStorage.setItem(CACHE_KEY, JSON.stringify({
          country,
          timestamp: Date.now()
        }))
      } catch (error) {
        console.error('Geolocation error:', error)
        // Default to showing content on error
        setCountryCode('US')
      } finally {
        setIsLoading(false)
      }
    }

    fetchGeo()
  }, [])

  return { countryCode, isLoading }
}
